import { PureComponent } from 'react';
import { NewsTitle, NewsDateAndProvider } from './styled';

interface NewsListingItemProps {
  url: string;
  index: number;
  headline: string;
  providerName: string;
  dateDiffFriendly: string;
  handleNavigationToURL: (url: string, index: number) => void;
}

class NewsListingItem extends PureComponent<NewsListingItemProps> {
  static defaultProps = {
    url: '',
    index: null,
    headline: '',
    providerName: '',
    dateDiffFriendly: '',
    handleNavigationToURL: null,
  };

  handleNavigationToURL = () => {
    const { url, index, handleNavigationToURL } = this.props;
    handleNavigationToURL(url, index);
  };

  render() {
    const { handleNavigationToURL } = this;
    const { url, headline, providerName, dateDiffFriendly } = this.props;

    return (
      <>
        <NewsDateAndProvider>
          {dateDiffFriendly} | {providerName}
        </NewsDateAndProvider>
        <NewsTitle
          as="a"
          styleType="softLink"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleNavigationToURL}
        >
          {headline}
        </NewsTitle>
      </>
    );
  }
}

export default NewsListingItem;
